<template>
  <div>
    <div class="grid grid-cols-4 gap-8 mx-12">
      <div
        v-for="outfitter in outfitters"
        :key="outfitter.id"
        @click="handleClick(outfitter)"
        class="text-center cursor-pointer"
      >
        <img class="mx-auto mb-4" :src="outfitter.logo_path" />
        {{ outfitter.name }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomePage",
  components: {},
  data() {
    return {};
  },
  methods: {
    handleClick(outfitter) {
      this.$router.push("/outfitter/" + outfitter.slug + "/1");
    },
  },
  computed: {
    outfitters: function () {
      return this.$store.getters["publicRoutes/getOutfitters"];
    },
  },
  mounted() {
    this.$store.dispatch("publicRoutes/getOutfitters");
    this.$store.dispatch("order/clear_order");
    this.$store.dispatch("search/clear_displayGroups");
  },
};
</script>
